export const PLATFORM_ROUTES = {
  LOGIN: '/platform/login',
  DASHBOARD: '/platform/dashboard',
  COMPANIES: '/platform/companies',
  COMPANY_CREATE: '/platform/companies/new',
  COMPANY_DETAIL: '/platform/companies/:id',
  SUBSCRIPTIONS: '/platform/subscriptions',
  // Phase 12.4E — subscription detail (D-109 §1).
  SUBSCRIPTION_DETAIL: '/platform/subscriptions/:id',
  COMMUNICATION: '/platform/communication',
  COMMUNICATION_TEMPLATES: '/platform/communication/templates',
  COMMUNICATION_GATEWAYS: '/platform/communication/gateways',
  COMMUNICATION_LOGS: '/platform/communication/logs',
  PLATFORM_USERS: '/platform/users',
  OPERATIONS_MONITORING: '/platform/operations/monitoring',
  OPERATIONS_JOBS: '/platform/operations/jobs',
  OPERATIONS_AUDIT: '/platform/operations/audit',
  STORAGE_DASHBOARD: '/platform/storage',
  STORAGE_ASSETS: '/platform/storage/assets',
  STORAGE_PROVIDERS: '/platform/storage/providers',
  // Administrator setup guide for the AWS S3 provider. A CHILD of the providers
  // route on purpose: it documents that page and is opened from it in a new tab.
  //
  // It must live under `/platform` — `App.tsx` branches on
  // `pathname.startsWith('/platform')`, so a top-level `/documentation/...` path
  // would boot the TENANT app, which has no such route and uses tenant auth.
  // Registered inside `PlatformProtectedRoute` like every other platform page,
  // so the guide is authenticated-admin-only rather than public.
  STORAGE_PROVIDER_AWS_GUIDE: '/platform/storage/providers/aws-s3-guide',
  /** Same reasoning as the AWS guide above — a child of the providers route. */
  STORAGE_PROVIDER_R2_GUIDE: '/platform/storage/providers/cloudflare-r2-guide',
  STORAGE_POLICIES: '/platform/storage/policies',
  STORAGE_MIGRATION: '/platform/storage/migration',
  // OQ-R2 / D-13. Provider-to-provider migrations live on their OWN namespace.
  // STORAGE_MIGRATION above is the LOCAL PATH migration centre (OQ-AME-1); the
  // two are deliberately not merged.
  STORAGE_PROVIDER_MIGRATIONS: '/platform/storage/provider-migrations',
  STORAGE_HEALTH: '/platform/storage/health',
  STORAGE_QUARANTINE: '/platform/storage/quarantine',
  STORAGE_SETTINGS: '/platform/storage/settings',
  SETTINGS: '/platform/settings',
  PROFILE: '/platform/profile',
} as const;

export type PlatformRoute = (typeof PLATFORM_ROUTES)[keyof typeof PLATFORM_ROUTES];
